import { getAddress, parseUnits, type Address } from "viem";

export const APP_NAME = "每月一枚 aiAVAX";
export const CHAIN_ID = 43_114;
export const RPC_URL = "https://api.avax.network/ext/bc/C/rpc";
export const DATA_API_URL = "https://data-api.avax.network/v1";

export const WALLET_ADDRESS = getAddress(
  "0x4938a8A05b80A7898D5081820655BEE5dC066ffB",
);
export const AIAVAX_ADDRESS = getAddress(
  "0xa845Cbe370B99AdDaB67AfE442F2cF5784d4dC29",
);
export const WAVAX_ADDRESS = getAddress(
  "0xB31f66AA3C1e785363F0875A1B74E27b85FD66c7",
);
export const AVAX_USD_FEED_ADDRESS = getAddress(
  "0x0A77230d17318075983913bC2145DB16C7366156",
);

export const AIAVAX_DECIMALS = 18;
export const MONTHLY_TARGET = parseUnits("1", AIAVAX_DECIMALS);
export const MONTH_COUNT = 12;
export const ORACLE_STALE_AFTER_SECONDS = 2 * 60 * 60;

export const EXPLORER_BASE_URL = "https://snowtrace.io";

export function sameAddress(left: Address | string, right: Address | string) {
  return left.toLowerCase() === right.toLowerCase();
}
